export default "__VITE_ASSET__CesWxyIz__"